import ActionsForm from '@/shared/mixins/actionsForm'
import ModalAddress from './modal/addressmodal.vue'

export default {
  name: 'CrmDetailsAddress',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    address: {
      type: Array,
      default: []
    },
    cardActive: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      data: null,
      form: null
    }
  },
  components: {
    ModalAddress
  },
  methods: {
    onLoad () {
    },
    onNewAddress () {
      this.$refs.ModalAddress.showModal()
    },
    onReload () {
      this.$emit('Reload')
    },
    formatCep (cep) {
      var re = /^([\d]{5})([\d]{3})/
      if (re.test(cep)) {
        // eslint-disable-next-line no-useless-escape
        return cep.replace(re, '\$1-\$2')
      } else {
        return 'CEP inválido!'
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/addresses/address.js